<template>
  <div style="position: relative">
    <div id="container" v-loading="isLoading"></div>
  </div>
</template>
<script>
import AMap from "AMap";
import { positionApi } from "@/services/all-api.js"
export default {
  data() {
    return {
      mapStyle: 'amap://styles/1ef2f1af9307ce936a12580cfa8170f8',
      map: "",
      markerList: [],
      markerData: [],
      isLoading: true,
      loopTimer: null
    }
  },
  props: {
    olderGid: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
  },
  methods: {
    init() {
      var vm = this;
      vm.map = new AMap.Map('container', {
        viewMode: '3D',
        turboMode: false,
        showIndoorMap: true,
        defaultCursor: 'pointer',
        showBuildingBlock: true,
        zooms: [3, 23],
        showLabel: true,
        zoom: 15,
        pitch: 45,
        rotation: 0,
        center: [105.73185, 29.703476],
        mapStyle: "amap://styles/1ef2f1af9307ce936a12580cfa8170f8"
      });
      vm.map.setFeatures(["building", "road", "point", "bg"]);
    },
    async renderIcons(reqObj) {
      var vm = this
      this.isLoading = true
      try {
        await positionApi.getOneOlderRecordApi({ ...reqObj }).then(
          result => {
            var zoomStyleMapping1 = {
              3: 0,
              4: 0,
              5: 0,
              6: 0,
              7: 0,
              8: 0,
              9: 0,
              10: 0,
              11: 0,
              12: 0,
              13: 0,
              14: 0,
              15: 0,
              16: 0,
              17: 0,
              18: 0,
              19: 0,
              20: 0,
              21: 0,
              22: 0,
              23: 0,
            }
            if (result.code === 0) {
              let res = result.data
              function markerClick(e) {
                infoWindow.setContent(e.target.content)
                infoWindow.open(vm.map, e.target.getPosition());
              }
              for (let item of res.Data) {
                this.markerData = res.Data.map(item => ({ ...item, lat: item.GLat || 31.231612, lon: item.GLon || 121.472188, }))
                let marker = new AMap.ElasticMarker({
                  position: [item.GLon || 98.2878, item.GLat || 39.7774235],
                  zooms: [3, 20],
                  styles: [{
                    icon: {
                      // img: require("@/assets/images/eleTouxiang1.png"),
                      img: require("@/assets/images/mass_red.png"),
                      size: [24, 24], //可见区域的大小
                      ancher: [16, 16],
                      fitZoom: 16, //最合适的级别
                      scaleFactor: 2, //地图放大一级的缩放比例系数
                      maxScale: 1.6, //最大放大比例
                      minScale: 1.0 //最小放大比例
                    }
                  }],
                  zoomStyleMapping: zoomStyleMapping1
                })
                marker.content =
                  `<div class="infoContainer">
                  <div class="oneRow"><span class="text name">老人姓名:${item.UserName || '-'}</span></div>
                  <div class="oneRow"><span class="text">定位地址:${item.Address || '-'}</span></div>
                  <div class="oneRow"><span class="text">定位时间:${item.CreateTime || '-'}</span></div>
                </div>`;
                marker.on('click', markerClick)
                vm.markerList.push(marker)
              }
              vm.map.add(this.markerList)
              if (res.Data.length && res.Data.length > 0) {
                let posObj = getAveragePosition(res.Data)
                let position = new AMap.LngLat(posObj.lon, posObj.lat);
                vm.map.setCenter(position);
              }

            }
          }
        )
      } catch (err) {
        console.log(err)
      } finally {
        this.isLoading = false
      }
    },
    loadData(reqObj) {
      this.renderIcons(reqObj)
      if (this.loopTimer) {
        clearInterval(this.loopTimer)
      }

      this.loopTimer = setInterval(() => {
        this.renderIcons(reqObj)
      }, 60000)
    },
    getAveragePosition(arr) {
      let longSum = 0;
      let latSum = 0;
      let length = arr.length;
      for (let item of arr) {
        longSum += item.GLon;
        latSum += item.GLat
      }
      return { lon: (longSum / length).toFixed(6), lat: (latSum / length).toFixed(6) }
    }
  },
  mounted() {
    this.init();
    this.$nextTick(() => {
      this.loadData({ index: 0, size: 20, userId: this.olderGid, start: this.Utils.dateFormat(this.date, 'YYYY-MM-DD 00:00:00'), end: this.Utils.dateFormat(this.date + 86400000, 'YYYY-MM-DD 00:00:00') });
    });
  },
  beforeDestroy() {
    clearInterval(this.loopTimer)
  }
}
</script>
<style>
#container {
  height: 200px;
}
</style>